import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Perspective from "@/components/Perspective";
import LiveSchedule from "@/components/LiveSchedule";
import Services from "@/components/Services";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#020510] text-[#F1F5F9]">
      <Navbar />
      <Hero />
      <Perspective />
      <LiveSchedule />
      <Services />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
